import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import {
  ApplicationContextProps,
  ApplicationContextProvider,
} from '../hooks/Context';
import { SendAnalyticsData } from '../lib/AnalyticsUtil';
import { Root, ScrollToTop } from './Default';
import AboutPage from './routes/AboutPage';
import AboutPageSf from './routes/AboutPageSf';
import TopPage from './routes/TopPage';
import TopPageSf from './routes/TopPageSf';
import { theme, themeSf } from './theme';

const App = (): React.ReactElement => {
  const props: ApplicationContextProps = IS_SF
    ? {
        urlBasePath: '/',
        jsonBasePath: '/json_sf/',
        theOtherSiteJsonBasePath: 'json/',
        layoutBasePath: '/layouts_sf/',
        faviconPath: '/favicon.svg',
        theme: themeSf,
        headerProps: {
          logoSrc: '/img/logo_sf.svg',
          buttonIconSrc: '/img/logo.svg',
          buttonIconSmallSrc: '/img/button.svg',
          buttonIconBackgroundColor: theme.palette.primary.main,
          linkPath: IS_PRODUCTION
            ? 'https://gtstats.info/'
            : 'https://supergt-dev-test.web.app/',
        },
        topPage: <TopPageSf />,
        aboutPage: <AboutPageSf />,
      }
    : {
        urlBasePath: '/',
        jsonBasePath: '/json/',
        theOtherSiteJsonBasePath: 'json_sf/',
        layoutBasePath: '/layouts/',
        faviconPath: '/favicon.svg',
        theme: theme,
        headerProps: {
          logoSrc: '/img/logo.svg',
          buttonIconSrc: '/img/logo_sf.svg',
          buttonIconSmallSrc: '/img/button_sf.svg',
          buttonIconBackgroundColor: themeSf.palette.primary.main,
          linkPath: IS_PRODUCTION
            ? 'https://sfstats.info/'
            : 'https://test-sf-statistics.web.app/',
        },
        topPage: <TopPage />,
        aboutPage: <AboutPage />,
      };
  return (
    <React.StrictMode>
      <React.Suspense fallback={<></>}>
        <BrowserRouter>
          <SendAnalyticsData />
          <ScrollToTop />
          <Switch>
            <Route
              path={'/'}
              render={() => (
                <ApplicationContextProvider {...props}>
                  <Root basePath="/" />
                </ApplicationContextProvider>
              )}
            />
          </Switch>
        </BrowserRouter>
      </React.Suspense>
    </React.StrictMode>
  );
};

export default App;
